import { Injectable } from "@angular/core";
import { FormBuilder, UntypedFormGroup, Validators } from "@angular/forms";


@Injectable({
    providedIn: "root",
})
export class GettingStartedForms extends FormBuilder {

    /**
     * Get Transaction Period And Expire Form Method
     */
    getAccessPeriodFormForm(): UntypedFormGroup {
        return super.group({
            accessFrom: [null, [Validators.required]],
            accessTo: [null, Validators.required],
        });
    }

}